import React, { useContext } from 'react'

import { AddColumnDialog, ColumnForm } from '@pages/EntityCreateOrEdit'
import { getColumnScriptConfig } from '@pages/TimeLineCreateOrEdit/helpers/hints/getColumnScriptConfig'

import { MODEL_TYPE } from '@constants'

import { getColumnDialogScript } from '../../helpers'
import { PageContext } from '../../TimeLineCreateOrEdit'

export const ObjectXAddColumnDialog = () => {
  const {
    handlers: contextHandlers,
    state: contextState,
    data: contextData,
  } = useContext(PageContext)
  const { handleCloseObjectXAddColumnDialog, handleChangeObjectXColumns, handleSaveTimeLine } =
    contextHandlers
  const {
    objectXShowAddColumnDialog,
    objectXAddColumnDialogData,
    watchObjectYObject,
    watchObjectXObject,
    watchVariables,
    isCreateOrUpdateLoading,
  } = contextState
  const { objectYSelectedObjectFields } = contextData

  const handleCreateColumn = (column: ColumnForm) => {
    handleChangeObjectXColumns(column)

    return handleSaveTimeLine()
  }

  const handleUpdateColumn = (column: ColumnForm) => {
    handleChangeObjectXColumns(column)

    return handleSaveTimeLine()
  }

  if (objectXAddColumnDialogData) {
    return (
      <AddColumnDialog
        {...objectXAddColumnDialogData}
        isAllowPinningAllColumns
        isUseNewScriptDialog
        loading={isCreateOrUpdateLoading}
        showDialog={objectXShowAddColumnDialog}
        type={MODEL_TYPE.TIMELINE_OBJECT_X_COLUMN}
        jsJSXHint={getColumnDialogScript({
          objectX: watchObjectXObject,
          objectY: watchObjectYObject,
          variables: watchVariables,
        })}
        scriptConfig={getColumnScriptConfig({
          variables: watchVariables,
          objectYFields: objectYSelectedObjectFields,
        })}
        onCloseModal={handleCloseObjectXAddColumnDialog}
        onCreateColumn={handleCreateColumn}
        onUpdateColumn={handleUpdateColumn}
      />
    )
  }
}
